import React from 'react';
import Svg from '../Svg';

const IconContrast03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM15.2271 5.88737C15.574 5.65328 16.0299 5.65987 16.3698 5.9039C18.2633 7.26329 19.5 9.48723 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C9.48723 19.5 7.26329 18.2633 5.9039 16.3698C5.65987 16.0299 5.65328 15.574 5.88737 15.2271C6.12146 14.8803 6.54673 14.7159 6.95324 14.8151C7.44797 14.9358 7.96581 15 8.5 15C12.0899 15 15 12.0899 15 8.5C15 7.96581 14.9358 7.44797 14.8151 6.95324C14.7159 6.54673 14.8803 6.12146 15.2271 5.88737ZM16.9338 9.56617C16.453 13.4081 13.4081 16.453 9.56617 16.9338C10.3 17.2965 11.1263 17.5 12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 11.1263 17.2965 10.3 16.9338 9.56617Z"
    />
  </Svg>
);

export default IconContrast03;
